import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from '@trileuco/triskel-react-ui/components/i18n'
import Page from 'components/layout/Page'
import PublicPageSkeleton from 'components/layout/pageSkeletons/PublicPageSkeleton'
import BoundedPageTemplate from 'components/layout/pageTemplates/BoundedPageTemplate'
import BlogBreadcrumb from 'modules/blog/components/BlogBreadcrumb'
import TagsCloud from 'modules/blog/components/TagsCloud'
import ArticleList from 'modules/blog/components/ArticleList'
import _ from 'lodash'
import { LoadingResults, useGetWebpage } from 'components/api'
import { NotFoundError } from 'components/error'

const ArchivePage = ({
  match: {
    params: { tag }
  }
}) => {
  const { msg } = useIntl({
    ignoreGlobalScope: true,
    scope: 'blog.articles'
  })
  const { webpage: blogWebpage, loading } = useGetWebpage({ id: 'blog' })
  if (loading) {
    return <LoadingResults />
  }
  if (!blogWebpage) {
    throw new NotFoundError('Webpage not found for slug blog')
  }
  const {
    content: { archive, lastEntries }
  } = blogWebpage
  return (
    <Page id="ArchivePage">
      <PublicPageSkeleton
        mainContent={
          <BoundedPageTemplate
            header={<BlogBreadcrumb />}
            mainContent={
              <ArticleList
                showLoadMoreButton
                title={msg({ id: 'tagResults' }, { tag: tag })}
                tag={tag}
              />
            }
            sidebar={
              <>
                <TagsCloud
                  title={_.get(archive, 'title.text') || msg({ id: 'archive' })}
                />
                <ArticleList
                  title={
                    _.get(lastEntries, 'title.text') ||
                    msg({ id: 'lastArticles' })
                  }
                  view="mini"
                  pageSize={_.get(lastEntries, 'limit') || 10}
                />
              </>
            }
          />
        }
      />
    </Page>
  )
}

ArchivePage.propTypes = {
  match: PropTypes.object
}

ArchivePage.displayName = 'ArchivePage'

export default ArchivePage
